import {OnboardingService} from './OnboardingService';

export default OnboardingService;